import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import * as _ from 'lodash';
import { CommodityLineItemFormNames } from '../enums';

export function claimTypeGreaterThanZeroFieldValidator(claimTypes: string[], testFn: Function = () => true): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    if (!control || !control.parent) {
      return null;
    }

    const controlClaimType = control.parent.get(CommodityLineItemFormNames.ClaimTypeCd).value;
    return _.some(claimTypes, claimType => claimType === controlClaimType) && testFn() && (!control.value || control.value <= 0) ? { mustBeGreaterThanZero: true } : null;
  };
}

@Directive({
  selector: '[claimTypeGreaterThanZeroFieldValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: ClaimTypeGreaterThanZeroFieldValidatorDirective, multi: true }],
})
export class ClaimTypeGreaterThanZeroFieldValidatorDirective implements Validator {
  @Input() claimTypes: string[];

  validate(control: AbstractControl): { [key: string]: any } {
    return claimTypeGreaterThanZeroFieldValidator(this.claimTypes)(control);
  }
}
